import PropTypes from 'prop-types';

import Layout from 'components/layout';
import BlogPosts from 'components/blog/BlogPosts';
import Header from 'components/blog/BlogIndexHeader';
import { getCategories, getAllPosts } from 'lib/api/posts';
import { BlogPostTileType } from 'utilities/propTypes';

export const getStaticProps = async ({ params }) => {
  const { category } = params;
  const posts = await getAllPosts({ category });
  return {
    props: {
      posts,
      category,
    },
  };
};

export const getStaticPaths = async () => {
  const categoriesWithPosts = await getCategories({});
  const paths = categoriesWithPosts.map((category) => {
    return {
      params: {
        category,
      },
    };
  });

  return {
    paths,
    fallback: false,
  };
};

export default function CategoryPage({ posts, category }) {
  return (
    <Layout
      title="Resistbot News"
      description="Opinion articles from our volunteers and news about Resistbot features."
    >
      <Header category={category} level="h1"></Header>
      <BlogPosts posts={posts}></BlogPosts>
    </Layout>
  );
}

CategoryPage.propTypes = {
  posts: PropTypes.arrayOf(BlogPostTileType).isRequired,
  category: PropTypes.string.isRequired,
};
